import BigNumber from "bignumber.js";
export function serialize({ amount, recipient, family, }) {
    return {
        amount: amount.toString(),
        recipient,
        family,
    };
}
export function deserialize({ amount, recipient, family, }) {
    return {
        amount: new BigNumber(amount),
        recipient,
        family,
    };
}
//# sourceMappingURL=serializer.js.map